// extracted by mini-css-extract-plugin
export default {"dotSpinner":"Loader_dotSpinner__ZwUW9","background":"Loader_background__-jtbm","dotSpinnerDot":"Loader_dotSpinnerDot__90o8S","pulse0112":"Loader_pulse0112__D24pl"};